var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    { staticClass: "contact-edit-root" },
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            { attrs: { "drawer-button-disabled": _vm.drawerButtonDisabled } },
            [
              _c(
                "w-toolbar-text",
                {
                  staticClass: "app-title",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [_vm._v(" " + _vm._s(_vm.title) + " ")]
              ),
              _vm.contact.ID != 0
                ? _c(
                    "w-toolbar-item",
                    {
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          return _vm.remove()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "trash" } })],
                    1
                  )
                : _c(
                    "w-toolbar-item",
                    {
                      attrs: { white: "", disabled: _vm.lastLoadedDisabled },
                      on: {
                        click: function ($event) {
                          return _vm.loadLastOpenedItem()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "clone" } })],
                    1
                  ),
              !_vm.isInfo
                ? _c(
                    "w-toolbar-item",
                    {
                      attrs: { white: "", disabled: _vm.saveDisabled },
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "save" } })],
                    1
                  )
                : _vm._e(),
              _c(
                "w-toolbar-item",
                {
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-container",
        [
          _c(
            "w-row",
            { attrs: { "no-wrap": "" } },
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-wrap": "" } },
                    [
                      _c("w-tabs", {
                        attrs: { tabs: _vm.tabs },
                        model: {
                          value: _vm.tab,
                          callback: function ($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab",
                        },
                      }),
                      !_vm.$wf.isSmDown && !_vm.isInfo
                        ? [
                            _c("w-spacer"),
                            _vm.dropDownItems.length > 0
                              ? _c(
                                  "w-dropdown",
                                  {
                                    staticClass: "mr",
                                    attrs: {
                                      items: _vm.dropDownItems,
                                      right: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.dropdownInput($event)
                                      },
                                    },
                                  },
                                  [_c("w-fa", { attrs: { icon: "bars" } })],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "w-button",
                              {
                                attrs: {
                                  icon: "check",
                                  disabled: _vm.saveDisabled,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.save()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("common.save")) + " "
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            { staticClass: "content", attrs: { tag: "div" } },
            [
              _c(
                "transition",
                { attrs: { name: "fast-fade", mode: "out-in" } },
                [
                  _vm.currentTabKey == "general"
                    ? _c("app-tab-1", {
                        attrs: {
                          contact: _vm.contact,
                          "has-invoices-that-were-sent-over-peppol":
                            _vm.hasInvoicesThatWereSentOverPeppol,
                        },
                        on: {
                          "check-if-vat-exists": function ($event) {
                            return _vm.checkIfVatExists()
                          },
                        },
                      })
                    : _vm.currentTabKey == "addresses"
                    ? _c("app-tab-2", {
                        ref: "Addresses",
                        attrs: { contact: _vm.contact },
                      })
                    : _vm.currentTabKey == "extra-info"
                    ? _c("app-tab-4", { attrs: { contact: _vm.contact } })
                    : _vm.currentTabKey == "extra-fields"
                    ? _c("app-tab-3", {
                        attrs: {
                          value: _vm.contact.ExtraFields,
                          "group-id": _vm.contact.GroupID,
                        },
                      })
                    : _vm.currentTabKey == "documents"
                    ? _c("app-tab-5", { attrs: { contact: _vm.contact } })
                    : _vm.currentTabKey == "price-rules"
                    ? _c("app-tab-6", { attrs: { contact: _vm.contact } })
                    : _vm.tab < _vm.extraFieldTabStart
                    ? _c("app-custom-view-tab-frames", {
                        attrs: {
                          model: _vm.contact,
                          tab: _vm.tab,
                          "start-tab-index": _vm.defaultTabs.length,
                          tabs: _vm.customViewTabs,
                        },
                        on: {
                          "update-parent": function ($event) {
                            return _vm.onUpdateParent($event)
                          },
                        },
                      })
                    : _c("app-extra-field-tab", {
                        key: "extra-field-" + _vm.tab,
                        attrs: {
                          value: _vm.contact.ExtraFields,
                          tab: _vm.extraFieldTabs[
                            _vm.tab - _vm.extraFieldTabStart
                          ],
                          "name-settings": _vm.extraFieldNamesConfig,
                        },
                      }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }